import * as React from 'react';
import './passwordChangePane.module.scss';
import { observer, inject } from 'mobx-react';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { observable, makeObservable } from 'mobx';
import { FormInput } from '../../atoms/forms/FormInput';
import { PasswordChangePaneState } from './states/PasswordChangePaneState';
import { SettingPane } from '../../molecules/mypage/page';
import { Button } from '@sheinc/shelikes-design-system';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

type Props = {
  homeState: HomePageState;
};

export const PasswordChangePane = inject('homeState')(
  observer(
    class PasswordChangePane extends React.Component<Props> {
      pageState = new PasswordChangePaneState();

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          pageState: observable,
        });
      }

      render() {
        const { submitting, formState } = this.pageState;
        return (
          <SettingPane activeMenu="password" title="パスワードの変更">
            <div styleName="form-label">現在のパスワード</div>
            <FormInput
              type="password"
              styleName="current_password"
              name="current_password"
              value={formState.getValue('current_password')}
              placeholder=""
              onChange={(e) => formState.setValue('current_password', e.target.value)}
              error={formState.getError('current_password')}
            />
            <div styleName="form-label">新しいパスワード</div>
            <FormInput
              type="password"
              styleName="password"
              name="password"
              value={formState.getValue('password')}
              placeholder=""
              onChange={(e) => formState.setValue('password', e.target.value)}
              error={formState.getError('password')}
            />
            <div styleName="form-label">新しいパスワードを再入力</div>
            <FormInput
              type="password"
              styleName="password_confirmation"
              name="password_confirmation"
              value={formState.getValue('password_confirmation')}
              placeholder=""
              onChange={(e) => formState.setValue('password_confirmation', e.target.value)}
              error={formState.getError('password_confirmation')}
            />
            <div styleName="form-submit-button">
              <Button
                disabled={submitting}
                onClick={() => this.pageState.submit()}
                fullWidth={GlobalStatesV3.viewport.isSp}
              >
                保存する
              </Button>
            </div>
          </SettingPane>
        );
      }
    }
  )
);
